import { useEffect, useState } from 'react';

declare global {
  interface Window {
    gtranslateSettings?: {
      default_language: string;
      native_language_names: boolean;
      detect_browser_language: boolean;
      languages: string[];
      wrapper_selector: string;
      float_switcher_open_direction?: string;
      switcher_horizontal_position?: string;
      switcher_vertical_position?: string;
      flag_style: string;
    };
  }
}

interface GTranslateProps {
  className?: string;
}

export default function GTranslate({ className = 'gtranslate_wrapper' }: GTranslateProps) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted) return;

    // Check if script already exists
    if (document.querySelector('script[src*="cdn.gtranslate.net"]')) {
      return;
    }

    // Wait for the wrapper to be in the DOM before loading script
    const wrapper = document.querySelector(`.${className.split(' ')[0]}`);
    if (!wrapper) return;

    // Configure GTranslate as dropdown (not floating)
    window.gtranslateSettings = {
      default_language: 'en',
      native_language_names: true,
      detect_browser_language: false,
      languages: ['en', 'es', 'zh-CN', 'zh-TW', 'tl', 'vi', 'ko'],
      wrapper_selector: '.gtranslate_wrapper',
      flag_style: '3d',
    };

    // Small delay to ensure DOM is fully ready
    const timer = setTimeout(() => {
      const script = document.createElement('script');
      script.src = 'https://cdn.gtranslate.net/widgets/latest/dropdown.js';
      script.defer = true;

      // Add onload handler to set attributes immediately after script creates selects
      script.onload = () => {
        // Wait a moment for GTranslate to create the selects
        setTimeout(() => {
          const selects = document.querySelectorAll(
            '.gtranslate_wrapper select, .gtranslate_wrapper .gt_selector',
          ) as NodeListOf<HTMLSelectElement>;

          selects.forEach((select, index) => {
            if (!select.id) {
              select.id = index === 0 ? 'language-selector' : `language-selector-${index}`;
            }
            if (!select.name) {
              select.name = index === 0 ? 'language-selector' : `language-selector-${index}`;
            }
          });
        }, 100);
      };

      document.body.appendChild(script);
    }, 100);

    return () => clearTimeout(timer);
  }, [isMounted, className]);

  // Keep the empty wrapper in SSR so its reserved geometry is present before hydration.
  return <div className={className} />;
}
